import { IssueStatus } from '../interfaces/IIssueShared';

export const ongoingIssuesStatuses: IssueStatus[] = Object.values(IssueStatus).filter(
	(status) => status !== IssueStatus.COMPLETED
);
